/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HUMAN_RESOURCES_QUERY_NAME, ME_QUERY_NAME } from '../constants';

const useHumanResourceMutation = (cb: Function) => {
  const queryClient = useQueryClient();

  return useMutation((data: any) => cb(data), {
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([HUMAN_RESOURCES_QUERY_NAME]),
        queryClient.invalidateQueries([ME_QUERY_NAME]),
      ]),
    // eslint-disable-next-line no-console
    onError: (error) => console.log(error),
  });
};

export default useHumanResourceMutation;